/**
 * @generated SignedSource<<cc840aae9468370a88f2c2ef0b3cd33c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoleAssignmentTable_principal$data = {
  readonly roleAssignments: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly role: {
          readonly name: string;
        };
        readonly source: {
          readonly __typename: string;
        } | null | undefined;
        readonly target: {
          readonly __typename: "AccountGroup";
          readonly name: string;
          readonly uuid: any;
        } | {
          readonly __typename: "PolicyCollection";
          readonly name: string;
          readonly uuid: any;
        } | {
          readonly __typename: "Repository";
          readonly name: string;
        } | {
          readonly __typename: "RepositoryConfig";
          readonly name: string;
          readonly uuid: any;
        } | {
          readonly __typename: "RoleScope";
          readonly displayName: string;
        } | {
          readonly __typename: "UserGroup";
          readonly name: string;
          readonly uuid: any;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        };
      };
    }> | null | undefined;
  };
  readonly " $fragmentType": "RoleAssignmentTable_principal";
};
export type RoleAssignmentTable_principal$key = {
  readonly " $data"?: RoleAssignmentTable_principal$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoleAssignmentTable_principal">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  (v1/*:: as any*/)
],
v3 = [
  (v1/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "uuid",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoleAssignmentTable_principal",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 100
        }
      ],
      "concreteType": "RoleAssignmentConnection",
      "kind": "LinkedField",
      "name": "roleAssignments",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RoleAssignmentEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RoleAssignment",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "source",
                  "plural": false,
                  "selections": [
                    (v0/*:: as any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Role",
                  "kind": "LinkedField",
                  "name": "role",
                  "plural": false,
                  "selections": (v2/*:: as any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "target",
                  "plural": false,
                  "selections": [
                    (v0/*:: as any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "displayName",
                          "storageKey": null
                        }
                      ],
                      "type": "RoleScope",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v3/*:: as any*/),
                      "type": "AccountGroup",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v3/*:: as any*/),
                      "type": "PolicyCollection",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v3/*:: as any*/),
                      "type": "RepositoryConfig",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v3/*:: as any*/),
                      "type": "UserGroup",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v2/*:: as any*/),
                      "type": "Repository",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "roleAssignments(first:100)"
    }
  ],
  "type": "RolePrincipal",
  "abstractKey": "__isRolePrincipal"
};
})();

(node as any).hash = "3139455c1100239efadbd28705e7eb89";

export default node;
